export default __webpack_public_path__ + "static/media/the-villa9.f32ebd19.webp";